import O1HD from "../../../engines/gameEngine";
import CsvDataManage from "../../../engines/managers/CsvDataManage";
import { ConditionKind } from "../../define/ConditionKind";
import { CsvFileKind } from "../../define/CsvFileKind";
import { MessageEventKind } from "../../define/MessageEventKind";
import { TaskKind } from "../../define/TaskKind";
import UserDataManage from "../model/UserDataManage";
import ConditionManage from "./ConditionManage";
import { TaskData } from "./DefineInterface";
import NormalGameManager from "./NormalGameManager";



// export interface TaskDataMap {
//     [type: string]: TaskData[];
// }

export default class TaskDataManage{

    private gameManger: NormalGameManager = null;

    /** 进行中的任务 */
    // private progressTaskList: TaskDataMap = {};

    private csvInfos: any = null;

    constructor(manager: NormalGameManager) {
        this.gameManger = manager;

        this.initData();
    }

    initData() {
        this.csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.TASK_LIST);
        // let gameData = this.gameManger.getGameData();
        // for (let o of gameData.taskDataList) {
        //     if (o.taskState == TaskKind.TaskState.UNDERWAY) {
        //         if (!this.progressTaskList[o.type]) {
        //             this.progressTaskList[o.type] = [];
        //         }
        //         this.progressTaskList[o.type].push(o);
        //     }
        // }
        
    }

    /**
     * 添加一个新任务
     * @param taskId 
     * @returns 
     */
    addNewTask(taskId: string) {
        let info = this.csvInfos[taskId];
        if (!info) {
            console.error(`未找到任务数据`);
            return;
        }
        // let curDay = this.gameManger.getCurrentDay();
        // let title = this.csvInfos.title;
        // let time = Number(info[title.time]);
        let gameData = this.gameManger.getGameData();
        if (gameData.taskDataMap[taskId]) {
            console.log('任务重复');
            return;
        }

        let taskItem: TaskData = {
            id: taskId
            , taskState: TaskKind.TaskState.UNDERWAY
        }
        gameData.taskDataMap[taskId] = taskItem;
        gameData.bNewTask = true
        this.gameManger.writeGameData();

        O1HD.emit(MessageEventKind.EventName.REFRESH_TASK_STATE);
    }

    /**
     * 添加一个新完成的任务
     * @param taskId 
     */
    addNewFinishTask(taskId: string) {
        let gameData = this.gameManger.getGameData();
        let taskData = gameData.taskDataMap[taskId];
        if (!taskData) {
            console.log('未找到任务数据');
            return;
        }
        if (taskData.taskState != TaskKind.TaskState.UNDERWAY) {
            console.log('任务已完成，重复任务');
            return;
        }
        taskData.taskState = TaskKind.TaskState.FINSH_NO_RECV;
        gameData.bNewFinshTask = true;
        this.gameManger.writeGameData();
        O1HD.emit(MessageEventKind.EventName.REFRESH_TASK_STATE);
    }

    addNewRecvAwardTask(taskId: string) {
        let gameData = this.gameManger.getGameData();
        this.gameManger.writeGameData();
    }

    /**
     * 每天更新任务状态
     * @returns 
     */
    everyDayUpdateState() {
        // let curDay = this.gameManger.getCurrentDay();
        // for (let i in this.progressTaskList) {
        //     let taskList = this.progressTaskList[i];
        //     for (let o of taskList) {
        //         if ((o.limitTime + o.openTime) <= curDay) {
        //             // 超过期限，弹窗结束
        //             this.doEndGame(o);
        //             return;
        //         }
        //     }
        // }
    }

    /**
     * 游戏结束
     * @param item 
     */
    doEndGame(item: TaskData) {

    }

    /**
     * 更新任务状态数据
     * @param dataType 
     * @returns 
     */
    updateData(dataType: ConditionKind.ConditionsType, ...arg: any[]) {
        // let taskLists = this.progressTaskList[dataType];
        // if (!taskLists) {
        //     return;
        // }
        // let title = this.csvInfos.title;
        // for (let i = taskLists.length-1; i >= 0 ; i--) {
        //     let o = taskLists[i];
        //     let info = this.csvInfos[o.id];
        //     if (!info) {
        //         console.error(`未找到`)
        //         continue;
        //     }
        //     let condValue = info[title.cond_find_value];
        //     let condRet = ConditionManage.instance.parseCondition(dataType, condValue);
        //     if (condRet.isFinish()) {
        //         this.addNewFinishTask(o.id);
        //         taskLists.splice(i, 1);
        //     }
        // }
    }

    /** 任务数据兼容 */
    dataCompatibility() {

        let TaskId = TaskKind.TaskId;
        let gameData = NormalGameManager._instance.getGameData();
        let matchMiaiData = UserDataManage.instance.matchMiaiDataManage.matchMiaiData;

        let taskId = TaskId.TASK_1;
        let taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (matchMiaiData.bEndGame || matchMiaiData.bEndSecond || matchMiaiData.bBridePrice) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_2;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (gameData.saveCupidFlag) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_3;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (matchMiaiData.bEndSecond || matchMiaiData.bBridePrice) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_8;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (matchMiaiData.bBridePrice) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_5;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (gameData.saveArcheryFlag) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_6;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (gameData.bFinishBoastGuiFei) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_7;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (gameData.isDeliveryWings) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }

        taskId = TaskId.TASK_9;
        taskData = gameData.taskDataMap[taskId];
        if (!taskData || taskData.taskState == TaskKind.TaskState.UNDERWAY) {
            if (gameData.liBaiGoodValue >= 100) {
                this.addNewTask(taskId);
                this.addNewFinishTask(taskId);
            }
        }
        // 
    }
    
}